import { getRequestHeader, getRequestProtocol } from 'h3';

// get app origin in both ssr and client modes. useNuxtApp().$origin
export default defineNuxtPlugin(({ ssrContext, provide }) => {
	const origin = import.meta.client
		? window.location.origin
		: (() => {
				const event = ssrContext?.event;
				if (!event) {
					return '';
				}
				const proto = getRequestProtocol(event);
				const host = getRequestHeader(event, 'host');
				return `${proto}://${host}`;
			})();

	provide('origin', origin);
});
